module.exports = __webpack_public_path__ + "img/xvc.8459152a.svg";